import axiosJava from "@/api/config_java";

//账户信息
export const accountInfoDetail = () => axiosJava.get(`/am/api/clientCompany/detail`);

//编辑账号信息
export const accountInfoEdit = param => axiosJava.post(`/am/api/clientCompany/update?${param}`);

//开户公司列表
export const accountCompanyList = param => axiosJava.get(`/am/api/accountCompany/list`, { params: param });

//添加开户公司
export const accountCompanyAdd = param => axiosJava.post(`/am/api/accountCompany/add`, param);

//编辑开户公司
export const accountCompanyUpdate = param => axiosJava.post(`/am/api/accountCompany/update?`, param);

//删除开户公司
export const accountCompanyDelete = id =>
  axiosJava.post(`/am/api/accountCompany/delete`, {
    accountCompanyId: id,
  });

//账号分组
export const getAccountGroup = () => axiosJava.get(`/am/api/accountGroup/list`);

//查看账户充值设置
export const viewRechargeSettings = param => axiosJava.get(`/am/api/accountInfo/viewRechargeSettings`);

//新增账户充值设置
export const addRechargeSettings = param => axiosJava.post(`/am/api/accountInfo/addRechargeSettings`, param);

//火箭用户列表
export const getPlatformUsers = param => axiosJava.get(`/am/api/accountInfo/platformUsers`, param);
